import { Box, BoxProps, ModBox, Text, TextProps } from '@jfs/ui-new'
import { getCategoryMetaData } from '../../../util/billPaymentUtil'
import { Colors } from '../../../util/util'
import { Logo } from '../Logo'

interface ItemsProps {
  title: string
  imageURL: string
  id: number
  shortName?: string
  searchTags?: string
  categoryId?: string
}

interface OperatorItemProps {
  item: ItemsProps
  onPress: (item: ItemsProps) => void
}

const OperatorItem = (props: OperatorItemProps) => {
  const { item, onPress } = props
  const handlePress = () => onPress(item)
  const imageURL = props?.item?.imageURL?.toLocaleLowerCase()
  return (
    <Box testID="operatorItem" {...styles.container} onPress={handlePress} underlayColor="TRANSPARENT">
      <ModBox>
        <Logo
          logo={imageURL ?? ''}
          type="medium"
          fallbackImageName={getCategoryMetaData(props?.item?.categoryId)?.icon}
        />
      </ModBox>
      <Box {...styles.containerRight}>
        <Text testID="title" {...styles.title}>
          {props.item?.title}
        </Text>
      </Box>
    </Box>
  )
}

const styles = {
  underlay: '#F0F0F0',
  container: {
    h: 70,
    flexDirection: 'row',
    alignItems: 'center',
  } as BoxProps,
  containerRight: {
    marginHorizontal: 12,
    flexShrink: 1,
    // paddingVertical: 12,
  } as BoxProps,
  title: {
    fontFamily: 'JioType-Medium',
    lineHeight: 20,
    fontSize: 14,
    color: Colors.BLACK_14,
  } as TextProps,
  nitificationIcon: {
    position: 'absolute',
    right: 8,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  arrowBox: {
    height: 25,
    width: 25,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    backgroundColor: 'GRAY_SHADOW',
  } as BoxProps,
}

export { OperatorItem }
